"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Audit;
    }
});
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _extractProps = require("~/helpers/extractProps");
const _globals = require("~/utils/globals");
const _modelUtils = require("~/utils/modelUtils");
const _PagedResponse = require("~/helpers/PagedResponse");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let Audit = class Audit {
    static async get(auditId, ncAudit = _Noco.default.ncAudit) {
        const audit = await ncAudit.metaGet2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.AUDIT, auditId);
        return audit && new Audit(audit);
    }
    // Will only await for Audit insertion if `forceAwait` is true, which will be true in test environment by default
    static async insert(audit, ncAudit = _Noco.default.ncAudit, { forceAwait, catchException = false } = {
        forceAwait: process.env['TEST'] === 'true'
    }) {
        try {
            if (process.env.NC_DISABLE_AUDIT === 'true') {
                return;
            }
            const propsToExtract = [
                'user',
                'ip',
                'source_id',
                'fk_workspace_id',
                'base_id',
                'row_id',
                'fk_model_id',
                'op_type',
                'op_sub_type',
                'description',
                'details',
                'user_agent',
                'version',
                'fk_user_id',
                'fk_ref_id',
                'fk_parent_id'
            ];
            const insertAudit = async ()=>{
                if (Array.isArray(audit)) {
                    const insertObjs = audit.filter((k)=>k).map((a)=>_extends({}, (0, _extractProps.extractProps)(a, propsToExtract), {
                            details: (0, _modelUtils.stringifyMetaProp)(a, 'details')
                        }));
                    return await ncAudit.bulkMetaInsert(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.AUDIT, insertObjs);
                } else {
                    const insertObj = (0, _extractProps.extractProps)(audit, propsToExtract);
                    return await ncAudit.metaInsert2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.AUDIT, _extends({}, insertObj, {
                        details: (0, _modelUtils.stringifyMetaProp)(insertObj, 'details')
                    }));
                }
            };
            if (forceAwait) {
                return await insertAudit();
            } else {
                insertAudit().catch((e)=>{
                    console.error('Error inserting audit', e);
                });
                return;
            }
        } catch (e) {
            if (!catchException) {
                console.error('Error inserting audit', e);
            } else {
                throw e;
            }
        }
    }
    static async recordAuditList(context, { fk_model_id, row_id, cursor }) {
        var _ref;
        if (!context.base_id || !fk_model_id || !row_id) {
            return new _PagedResponse.PagedResponseImpl([], {}, {
                pageInfo: {
                    isLastPage: true
                }
            });
        }
        const [id, _created_at] = (_ref = cursor == null ? void 0 : cursor.split('|')) != null ? _ref : [];
        const query = _Noco.default.ncAudit.knex(_globals.MetaTable.AUDIT);
        if (context.workspace_id) {
            query.where('fk_workspace_id', context.workspace_id);
        }
        query.where('base_id', context.base_id).where('fk_model_id', fk_model_id).where('row_id', row_id).orderBy('id', 'desc');
        if (id) {
            query.where('id', '<', id);
        }
        query.limit(this.limit + 1);
        const audits = await query;
        if (audits.length > this.limit) {
            audits.pop();
            return new _PagedResponse.PagedResponseImpl(audits, {}, {
                pageInfo: {
                    isLastPage: false
                }
            });
        }
        return new _PagedResponse.PagedResponseImpl(audits, {}, {
            pageInfo: {
                isLastPage: true
            }
        });
    }
    // TODO: remove this - it is deprecated and only used on unit tests
    static async baseAuditList(context, { page = 1, user, type, startDate, endDate, orderBy }) {
        const offset = (Math.max(1, page != null ? page : 1) - 1) * this.limit;
        if (!context.base_id) {
            console.error('Invalid context for baseAuditList', context);
            return [];
        }
        if (orderBy == null ? void 0 : orderBy.created_at) {
            orderBy.created_at = orderBy.created_at === 'asc' ? 'asc' : 'desc';
        }
        return await _Noco.default.ncAudit.metaList2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.AUDIT, {
            limit: this.limit,
            offset,
            orderBy: _extends({}, (orderBy == null ? void 0 : orderBy.created_at) ? {
                id: orderBy == null ? void 0 : orderBy.created_at
            } : {
                id: 'desc'
            }),
            xcCondition: {
                _and: [
                    ...context.workspace_id ? [
                        {
                            fk_workspace_id: {
                                eq: context.workspace_id
                            }
                        }
                    ] : [],
                    {
                        base_id: {
                            eq: context.base_id
                        }
                    },
                    {
                        version: {
                            eq: 1
                        }
                    },
                    ...user ? [
                        {
                            user: {
                                eq: user
                            }
                        }
                    ] : [],
                    ...startDate ? [
                        {
                            created_at: {
                                ge: startDate
                            }
                        }
                    ] : [],
                    ...endDate ? [
                        {
                            created_at: {
                                le: endDate
                            }
                        }
                    ] : [],
                    ...type ? [
                        {
                            op_type: {
                                in: type
                            }
                        }
                    ] : []
                ]
            }
        });
    }
    constructor(audit){
        Object.assign(this, audit);
    }
};
Audit.limit = 25;
